import { _ as __rest, a as __assign } from './tslib.es6-01f7d394.js';
import { c as classNames } from './index-8a7d9ef9.js';
import * as React from 'react';
import { useState } from 'react';
import { u as useCombinedRefs } from './useCombinedRefs-62622a74.js';
import { T as Typography } from './Typography-cdf537a9.js';

var styles = {"fileUpload":"FileUpload_fileUpload_c13ed92f","dragging":"FileUpload_dragging_c13ed92f","fileUploadButton":"FileUpload_fileUploadButton_c13ed92f","focus-visible":"FileUpload_focus-visible_c13ed92f","text":"FileUpload_text_c13ed92f","fileInput":"FileUpload_fileInput_c13ed92f","label":"FileUpload_label_c13ed92f","helpText":"FileUpload_helpText_c13ed92f"};

var FileUpload = React.forwardRef(function FileUpload(props, ref) {
    var className = props.className, onFileSelect = props.onFileSelect, label = props.label, color = props.color, helpText = props.helpText, otherProps = __rest(props, ["className", "onFileSelect", "label", "color", "helpText"]);
    var _a = useState(0), draggingLevel = _a[0], setDraggingLevel = _a[1];
    var dragging = draggingLevel > 0;
    var handleDragEnter = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDraggingLevel(draggingLevel + 1);
    };
    var handleDragLeave = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDraggingLevel(draggingLevel - 1);
    };
    var handleDragOver = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    var handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        onFileSelect(e.dataTransfer.files);
        setDraggingLevel(0);
    };
    var hiddenFileInput = useCombinedRefs(ref);
    var handleClick = function () {
        if (hiddenFileInput && hiddenFileInput.current) {
            hiddenFileInput.current.click();
        }
    };
    var handleChange = function (event) {
        var fileUploaded = event.target.files;
        if (fileUploaded) {
            onFileSelect(fileUploaded);
        }
    };
    return (React.createElement("div", null,
        label && (React.createElement(Typography, { className: classNames(styles.label, className), as: "div", "data-testid": "file-upload-label" }, label)),
        React.createElement("div", { className: classNames(styles.fileUpload, dragging && styles.dragging, className), onDrop: function (e) { return handleDrop(e); }, onDragOver: handleDragOver, onDragEnter: function (e) { return handleDragEnter(e); }, onDragLeave: function (e) { return handleDragLeave(e); }, onKeyDown: function (event) {
                if (event.key === "Enter") {
                    handleClick();
                }
            }, style: {
                "--color-component-primary": color !== null && color !== void 0 ? color : "var(--color-ui-action)",
            }, "data-testid": "file-upload" },
            React.createElement("button", { className: styles.fileUploadButton, type: "button", onClick: handleClick },
                React.createElement(Typography, { className: classNames(styles.text, className), as: "div" },
                    "Choose file",
                    props.multiple ? "s" : "")),
            React.createElement(Typography, { className: classNames(styles.text, className), as: "div" },
                "or drop file",
                props.multiple ? "s" : "",
                " here"),
            React.createElement("input", __assign({ ref: hiddenFileInput, type: "file", onChange: handleChange, style: { display: "none" }, "data-testid": "file-upload-input" }, otherProps))),
        helpText && (React.createElement(Typography, { className: classNames(styles.helpText, className), as: "p", "data-testid": "file-upload-help-text" }, helpText))));
});

export { FileUpload as F };
